// @cs2ts-begin-auto-generated
export enum PayViaOption {
	Card,
	Invoice
}

export enum ApiRole {
	Brushfire
}

export enum TypeDateOption {
	None,
	Always,
	Until,
	After,
	Between,
	Relative
}

export enum QueueForceOption {
	Default,
	ForceQueue,
	ForceDirect
}

export enum OrderQueueType {
	None,
	Standard,
	Bulk
}

export enum OAuthContext {
	Profile,
	Signin,
	Signup
}

export enum CustomQueryGranularity {
	Minute,
	Hour,
	Day
}

export enum EmailEvent {
	Processed,
	Dropped,
	Delivered,
	Deferred,
	Bounce,
	Open,
	Click,
	SpamReport,
	Unsubscribe
}

export enum TypeKind {
	InPerson,
	Donation,
	Product,
	Virtual
}

export enum ApiAccess {
	App,
	AppEnhancedByUser,
	User
}

export enum DateFormat {
	Long,
	ShortNice,
	ShortSlash
}

export enum PipelineContext {
	Initial,
	MoreInfo,
	Demo,
	Quote,
	Signup
}

export enum EmailType {
	SingleItem,
	SingleEvent,
	MultipleItem,
	MultipleEvent,
	Client,
	Internal
}

export enum UserChoices {
	Owner,
	Billing,
	Scanning,
	Agent,
	Accountant,
	Tech,
	Captain,
	Manager,
	Admin,
	Brushfire,
	BrushfireStaff
}

export enum EmailScope {
	EventAttendee,
	EventAttendeeUnique,
	EventGroup,
	EventOrder,
	ClientOrders,
	ClientMarketing,
	GroupEblast,
	SignatureEblast,
	Internal
}

export enum ExportScope {
	EventAttendee,
	EventGroup,
	EventOrder,
	ClientOrders,
	ClientMarketing
}

export enum EmailSendOption {
	Draft,
	Immediate,
	Scheduled
}

export enum RoutingCondition {
	IncludedClientAlso,
	NoClient,
	ReplaceWithClient,
	AreaAsSubdomain
}

export enum FieldMetaType {
	Order,
	Group,
	Attendee
}

export enum OrderLookupMethod {
	OrderNumber,
	AttendeeNumber,
	Last4
}

export enum ReportFormat {
	PDF,
	CSV,
	XLS
}

export enum ReportType {
	SSRS,
	DataDelivery,
	Preset
}

export enum ScheduledItemType {
	SSRS,
	DataDelivery,
	Preset,
	Eblast
}

export enum FieldUpdateType {
	Attendees,
	Groups,
	Buyer
}

export enum DataDeliveryType {
	Table,
	Grouped,
	Custom,
	Flow
}

export enum AssignmentFieldType {
	Value,
	Option,
	AttendeeType,
	Group,
	CompletedState
}

export enum StatsPeriod {
	Day,
	Month,
	Year,
	Overall
}

export enum BlobStorageDirectory {
	Media,
	Emails,
	Reporting
}

export enum EventVerbiage {
	Registrations,
	Tickets
}

export enum SectionAlignment {
	Left,
	Center,
	Right
}

export enum AccessCodeType {
	Event,
	AttendeeType,
	Seat,
	Product
}

export enum GridFilterType {
	Global,
	Date,
	Boolean,
	Number,
	String
}

export enum GridFilterOption {
	Relative,
	Between,
	LessThan,
	GreaterThan,
	Equals,
	NotEquals,
	Contains,
	NotContains,
	True,
	False,
	Null
}

export enum GridFilterDateOption {
	Months,
	Days
}

export enum FlagState {
	Yellow,
	Orange,
	Blue,
	Red,
	Green,
	Purple,
	Gray,
	Black,
	Aqua,
	Pink,
	Complete
}

export enum PrintType {
	Ticket,
	ETicket,
	Receipt,
	MailingLabel,
	WillCall,
	NameBadge,
	Season
}

export enum PrintFormat {
	PDF,
	PNG,
	JPG,
	GIF,
	BMP,
	TIFF,
	ZPL
}

export enum ShipType {
	Event,
	Product
}

export enum OrderType {
	Event
}

export enum ConversionTrackerType {
	Google,
	Facebook,
	Custom
}

export enum PromotionType {
	AttendeeType
}

export enum PromotionKind {
	Standard,
	Template,
	Dynamic
}

export enum AccessCodeKind {
	Standard,
	Template,
	Dynamic
}

export enum PromotionDynamicCodeMethod {
	Random,
	Sequential,
	File
}

export enum AccessDynamicCodeMethod {
	Random,
	Sequential,
	File
}

export enum PromotionPreset {
	Custom = 0,
	DollarsOff = 1,
	PercentageOff = 2,
	BuyOneGetOne = 3,
	BuySomeGetSome = 4,
	BuySomeGetDollarsOff = 5,
	BuySomeGetPercentageOff = 6,
	GroupDiscountDollars = 7,
	GroupDiscountPercentage = 8,
	EveryNthPersonDollars = 9,
	EveryNthPersonPercentage = 10
}

export enum SeatStyle {
	Seat,
	Pew,
	Spot
}

export enum InfoGrouping {
	None,
	CheckPO,
	ECheck,
	Card,
	AppSideload,
	Reference
}

export enum SeatingScheme {
	Consecutive,
	Odd,
	Even
}

export enum TransactionType {
	Authorize,
	Capture,
	AuthorizePlusCapture,
	Credit,
	Void,
	Invoice
}

export enum TenderType {
	Card,
	ECheck
}

export enum EventAccess {
	FullStop,
	Stop,
	Continue
}

export enum FieldType {
	Text,
	MultiText,
	Name,
	Address,
	Phone,
	Email,
	Dropdown,
	Checkboxes,
	Radiobuttons,
	Date,
	Accept,
	ItemList,
	ItemAmount,
	Paragraph,
	SectionHeader,
	Link,
	Signature,
	RemoteValidate,
	RemoteFetch
}

export enum SpecialFieldSuffix {
	First,
	Last,
	Street1,
	Street2,
	City,
	Region,
	Country,
	PostalCode
}

export enum PrivilegeLevel {
	Scanning = 0,
	Agent = 1,
	Accountant = 2,
	Tech_Limited = 4,
	Tech = 8,
	Captain = 16,
	Manager = 32,
	Admin_Limited = 64,
	Admin = 128,
	Brushfire = 256
}

export enum SecurityRole {
	None = 0,
	Scanning = 1,
	Sell = 2,
	Reports = 4,
	Manage = 8,
	Gateway = 16,
	Config = 32,
	Master = 64
}

export enum AttendeeStatus {
	Cart,
	InQueue,
	Reserved,
	Cancelled,
	Validating
}

export enum OAuthService {
	Facebook,
	Twitter,
	Google,
	Apple,
	FellowshipOne,
	Partner
}

export enum ChmsVendor {
	FellowshipOne
}

export enum SyncOrganizationOption {
	SingleOrder,
	SingleAttendee,
	OrderAttendees
}

export enum SyncEnvironmentOption {
	Production,
	Sandbox,
	Playground
}

export enum NamingScheme {
	Numeric,
	Alphabetic
}

export enum RowAlias {
	Rows,
	Tables,
	Pews
}

export enum SectionPropertyRank {
	Lowest,
	Highest
}

export enum ParameterType {
	String,
	Number,
	Boolean,
	DateTime,
	SelectList,
	Multiselect
}

export enum ReportIdentifier {
	DefaultReport = 0
}

export enum ReportDatePreset {
	FirstOfWeek,
	FirstOfLastWeek,
	FirstOfMonth,
	FirstOfLastMonth,
	FirstOfYear,
	FirstOfLastYear,
	Yesterday,
	Yesterday01,
	Yesterday02,
	Yesterday03,
	Yesterday04,
	Yesterday05,
	Yesterday06,
	Yesterday07,
	Yesterday08,
	Yesterday09,
	Yesterday10,
	Yesterday11,
	Yesterday12,
	Yesterday13,
	Yesterday14,
	Yesterday15,
	Yesterday16,
	Yesterday17,
	Yesterday18,
	Yesterday19,
	Yesterday20,
	Yesterday21,
	Yesterday22,
	Yesterday23,
	Today,
	Today01,
	Today02,
	Today03,
	Today04,
	Today05,
	Today06,
	Today07,
	Today08,
	Today09,
	Today10,
	Today11,
	Today12,
	Today13,
	Today14,
	Today15,
	Today16,
	Today17,
	Today18,
	Today19,
	Today20,
	Today21,
	Today22,
	Today23,
	Now
}

export enum LayoutPageRepeat {
	Every = 0,
	First = 1,
	Odd = 2,
	Even = 3,
	Last = 4
}

export enum LayoutFieldDisplay {
	FieldValue,
	FieldName,
	Blank
}

export enum LayoutFieldType {
	Field,
	Literal,
	TwoDBarCode,
	Image,
	DynamicImage,
	Line,
	Grid,
	PageNumber,
	Map,
	DynamicLiteral
}

export enum ShippingProvider {
	FedEx,
	UPS,
	USPS
}

export enum USPSPackageType {
	PaddedEnvelope,
	SmallBox,
	MediumBox,
	LargeBox,
	Parcel
}

export enum ShareButtonOrientation {
	Vertical,
	Horizontal
}

export enum GraphType {
	Line,
	Bar,
	Radar,
	Polar,
	Pie,
	Doughnut
}

export enum ASTMode {
	Sales,
	Management,
	Edit,
	Checkin
}

export enum SortDirection {
	Ascending,
	Descending
}

export enum SeatAddRemove {
	Add,
	Remove
}

export enum ReportIsLike {
	IsLike,
	DoesNotEqual,
	Equals,
	IsNotLike
}

export enum SessionType {
	Generic,
	AttendeeType,
	FieldOption
}

export enum ManualCheckinType {
	Attendee,
	Order,
	Group
}

export enum SignatureFieldParentType {
	Attendee,
	Order,
	Group
}

export enum ApiMethodId {
	Auth,
	AuthSocial,
	EventList,
	SessionList,
	SessionInfo,
	Attendees,
	Checkin,
	Checkout,
	AttendeeDetails,
	AttendeeLookup,
	AttendeeCode,
	OrderQuickCreate,
	SystemStats
}

export enum WebhookType {
	Attendee_Created,
	Attendee_Updated,
	Attendee_Cancelled,
	Order_Completed,
	Event_Created,
	Group_Updated,
	Group_Created,
	Group_Deleted,
	Zapier_Post,
	Event_Updated,
	Order_Updated,
	Client_Created,
	Client_Activated,
	Client_Deactivated,
	Email_Unsubscribe,
	Email_Resubscribe
}

export enum WebhookSentStatus {
	Processing,
	Success,
	Failure
}

export enum IntegrationItemType {
	User,
	Ticket
}

export enum AutoFees {
	Ours
}

export enum CommunityFillOption {
	Evenly,
	Ordered
}

export enum CommunityOrderOption {
	GroupsThenAttendees,
	AttendeesOnlyPlusOverwrite
}

export enum TrelloCategory {
	Feature,
	Idea,
	Bug
}

export enum TrelloCompany {
	Brushfire,
	HillsongTech
}

export enum TrelloProduct {
	MobileApp,
	WebApp,
	Marketing,
	Other
}

export enum TrelloPerspective {
	User,
	Admin,
	Staff,
	Partner
}

export enum DataPrivacyItemType {
	Order,
	Attendee,
	Group,
	Account,
	Event
}

export enum ManagePageView {
	Attendees,
	Addons,
	Orders,
	Groups,
	Reports,
	Emails,
	Analytics
}

export enum ClientApiKey {
	SendGrid
}

export enum EventSaveStatus {
	New,
	Creating,
	Created,
	Updating,
	Updated,
	Submitting,
	Submitted,
	Publishing,
	Published
}

export enum ImportEventType {
	AttendeeValid,
	AssignedSeatEvent,
	NoAttendeeTypes,
	NoNameField,
	NoEmailField
}

export enum EventEmailType {
	Directions,
	EmailUs,
	Share
}

export enum QueueType {
	AttendeeImport,
	CommunityAllocation,
	Email,
	EmailBlast,
	IntegrationSync,
	LargeEvent,
	Order,
	BulkOrder,
	Season,
	SeasonProcess,
	Subscription,
	TokenRefresh,
	Webhook,
	ArchiveRestore,
	BackgroundProcessor,
	LogProcessor,
	SquareRefresh,
	BackgroundBatchProcessor
}

export enum TimerFunction {
	ASTRelease,
	BrushfireStats,
	CleanCustomData,
	EmailBlast,
	Event,
	GARelease,
	IntegrationSync,
	LargeEvent,
	ManagerEmailBlast,
	Partner,
	Season,
	StripeAggregate,
	StuckOrderQueue,
	StuckValidating,
	Subscription,
	TokenRefresh,
	CurrentBalance,
	AutoArchive,
	GAManagedRelease,
	SquareRefresh,
	LogCleanup
}

export enum ArchiveType {
	Archive,
	Restore,
	CleanupDbo,
	CleanupArchive
}

export enum FlexPassEventType {
	None,
	All,
	Specific
}

export enum AuditLoggingType {
	Api,
	Developer,
	EventCreator,
	Functions,
	Webhooks,
	WidgetApi
}

export enum DomainValidationType {
	All,
	Only,
	None
}

export enum BackgroundJobType {
	AttendeesCL,
	QueueUtility,
	SeasonUtility,
	WebhookUtility
}

export enum DatabaseSequence {
	AccessCodesEvents,
	AccessCodesSeats,
	AttendeeTypesPrices,
	AttendeesPromotions,
	EmailsEvents,
	EventShipping,
	EventSessionsAttendeeTypes,
	EventSessionsOptions,
	Layouts,
	OrderAttendeesPromotions,
	Services,
	Events,
	Attendees,
	Orders,
	Clients,
	Accounts,
	EventSessions,
	Groups,
	Invoices,
	PartnerPayments
}

export enum AttendeeChangeType {
	All,
	Positive,
	None
}

export enum FlexDateComponent {
	Day,
	Month,
	Year
}

export enum CheckInTimeUnit {
	Minutes,
	Hours
}

export enum StuckOrderType {
	OrderJsonPresent,
	AttendeesNotInCartAttendees,
	CartAttendeesNotInAttendees
}

export enum SquarePaymentType {
	CARD,
	WALLET,
	BANK_ACCOUNT,
	BUY_NOW_PAY_LATER,
	GIFT_CARD,
	INVOICE
}

export enum SquarePaymentMethodConfigOption {
	Card,
	ApplePayGooglePay,
	BankAccount,
	AfterpayClearpay,
	GiftCard,
	CashApp
}

export enum SharedCapacityKind {
	Default,
	Time,
	Pass
}

export enum TicketRenderType {
	Assigned,
	AssignedSection,
	GeneralAdmission,
	FlexPass,
	TimeSlot,
	Groups,
	Orders
}

export enum PaymentSourceTypes {
	APPLE_PAY,
	GOOGLE_PAY,
	CASH_APP,
	BUY_NOW_PAY_LATER,
	GIFT_CARD,
	BANK_ACCOUNT,
	CARD,
	INVOICE
}

export enum GoogleAnalyticsStream {
	Admin,
	Developer,
	EventCreator,
	Portal
}

export enum SignatureStatus {
	PENDING,
	SIGNED,
	MISSING,
	VOIDED
}

export enum AttendeeTypeCategory {
	All,
	Standard,
	Addon
}

export enum InvoiceRelativeDays {
	UponReceipt = 0,
	SevenDaysAfterOrder = 7,
	FourteenDaysAfterOrder = 14,
	ThirtyDaysAfterOrder = 30,
	ThirtyDaysBeforeEvent = -30,
	FourteenDaysBeforeEvent = -14,
	SevenDaysBeforeEvent = -7,
	DueByEvent = -1
}
// @cs2ts-end-auto-generated
